import { useLocation } from "react-router-dom";
import { Pencil } from "lucide-react";
import { useAuth } from "../context/AuthContext";

// Small badge shown on public pages when an admin is logged in, hinting that text is editable.
export default function EditModeBanner() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  if (!user || user.role !== "admin" || pathname.startsWith("/admin")) return null;
  return (
    <div data-testid="edit-mode-banner" className="fixed bottom-6 left-6 z-40 inline-flex items-center gap-2 rounded-full bg-nead-ink px-4 py-2.5 text-sm font-medium text-white shadow-2xl border border-white/10">
      <Pencil className="h-4 w-4 text-nead-pink" />
      Edit mode: click any highlighted text to edit
    </div>
  );
}
